import {createApp} from 'vue/dist/vue.esm-bundler';
import axios from 'axios';
import VueAxios from 'vue-axios';
import ChatbotAppComponent from "./chatbotApp/app.vue";

const chatbotApp = createApp({});
const chatbotAppElement = $('#chatbot-app');
const processInclude = require('base/util');

chatbotApp.config.globalProperties.$urls = {
  homeUrl: chatbotAppElement.attr('home-url'),
  botUrl: chatbotAppElement.attr('bot-url'),
  getUserInfoUrl: chatbotAppElement.attr('get-user-info-url'),
  loginUrl: chatbotAppElement.attr('chat-login-url'),
  forgotPasswordUrl: chatbotAppElement.attr('chat-forgot-password-url'),
  registrationUrl: chatbotAppElement.attr('chat-registration-url'),
  refreshHeaderUrl: chatbotAppElement.attr('chat-refresh-header-url'),
  updateChatIdUrl: chatbotAppElement.attr('chat-update-chat-id-url'),
  sendMessageUrl: chatbotAppElement.attr('chat-send-message-url'),
  chatThreadIdUrl: chatbotAppElement.attr('chat-thread-id-url'),
  chatHistoryUrl: chatbotAppElement.attr('chat-history-url'),
  chatCheckMessagesUrl: chatbotAppElement.attr('chat-check-messages-url'),
  chatLikeProductUrl: chatbotAppElement.attr('chat-like-product-url'),
  chatFeedbackUrl: chatbotAppElement.attr('chat-feedback-url'),
  latestCollectionUrl: chatbotAppElement.attr('latest-collection-url'),
  iconicProductsUrl: chatbotAppElement.attr('iconic-products-url'),
  packagingUrl: chatbotAppElement.attr('packaging-url'),
  faqUrl: chatbotAppElement.attr('faq-url'),
  termsUrl: chatbotAppElement.attr('terms-url'),
  privacyUrl: chatbotAppElement.attr('privacy-url'),
}

chatbotApp.config.globalProperties.$csrf = JSON.parse(chatbotAppElement.attr('csrf'));
chatbotApp.config.globalProperties.$chatInputCharLimit = JSON.parse(chatbotAppElement.attr('chat-input-char-limit'));
chatbotApp.config.globalProperties.$googleReCaptchaKey = chatbotAppElement.attr('google-rec-key');
chatbotApp.config.globalProperties.$translations = JSON.parse(chatbotAppElement.attr('translations'));
chatbotApp.config.globalProperties.$chatbotAppElement = chatbotAppElement;

$(document).ready(function () {
    if (chatbotAppElement.length) {
        chatbotApp
            .component('chatbot-app', ChatbotAppComponent)
            .use(VueAxios, axios)
            .mount('#chatbot-app')

        processInclude(require('./tealium/tealiumREDEvents'));
    }
})
